<template>
  <tr v-if="item">
    <td>
      <div class="row">
        <!-- Image -->
        <div class="col-4 text-center">
          <img
            :src="item.imageUrl"
            class="img-fluid"
            style="max-height:8em;"
            @error="imgError">
        </div>
        <!-- Content -->
        <div class="col-8">
          <DisplayAction
            class="float-end"
            :record="record"
            :customer="customer"
            :item="item"/>
          <strong>{{ item.name }}</strong>
          <ul
            class="p-0"
            style="list-style-type: none;">
            <li>Priceline: {{ item.priceLine }}</li>
            <!-- <li>Product ID: {{ item.eclipseId }}</li> -->
            <li>Type: {{ item.merchandisingType }}</li>
            <li>Collection: {{ item.collection }}</li>
          </ul>
          <small class="text-muted float-end">
            Date Placed: {{ moment(record.datePlaced).format('DD-MM-YYYY') }}
          </small>
        </div>
      </div>
    </td>
  </tr>
</template>

<script setup>
  import comingSoon from '../../../../../../../shared/comingSoon'
  import DisplayAction from '../../components/DisplayAction.vue'
  
  // Initialize
  const props = defineProps(['record', 'item', 'customer'])

  // Methods
  const imgError = (e)=>{
    return comingSoon(e)
  }
</script>